
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './contact.scss';






const Pcontact = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id68abd8cd60a29c1eab0fc422" >

      <div id="iwt62" className="">
      
      <div id="icxk" className="">
      
      <div id="iin8q" className="">
      
      <div id="ify1g" className="">
      
      <img
        className=""
        id="ip8xoj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimermwqde.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i3em3e" className="">
      
        <LoftyDropdownComponent
          id="is1a6y"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ipkugh" className="gjs-dropdown-menu-trigger ">
<>
          Menu
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="ib7hlr" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="idegic"
          href={`/`}
        >
          
    <div id="iepxjg" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="icwogf"
          href={`/menu`}
        >
          
    <div id="iyyqt8" className="">
    <>Menu</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ieaz3v"
          href="#"
        >
          
    <div id="i4gyyj" className="">
    <>Contacto</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
      </div>
      
      <div id="i95gii" className="">
      
        <a
          target=""
          className=""
          id="ipz0pg"
          href={`/`}
        >
          
    <div id="i2vvpe" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwg0nn"
          href={`/menu`}
        >
          
    <div id="idbyah" className="">
    <>Menú</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iv95sw"
          href="#"
        >
          
    <div id="icq2ek" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="i1xxv" className="">
      
      <div id="inwavh" className="">
      
      <div className="" id="iybdaj">
        <>Deseas hacer una reserva o quieres celebrar un evento con nosotros?</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="inak" className="">
      
      <div className="" id="ihc7">
        <>Estamos aquí para ayudarte</>
      </div>
      
      </div>
      
      <div id="ivp9rg" className="">
      
      <div id="iyczei" className="">
      
      <div id="idi9lr" className="">
      
      <div id="ikpfw" className="">
      
      <div className="" id="ido6j">
        <>Estamos aquí para ayudarte.</>
      </div>
      
      </div>
      
      <div id="iiwfrh" className="">
      
      <div id="ijhsbc" className="">
      
      <div id="i6c9bg" className="">
      
      <span className="material-icons " id="i15nvh">
        
      <span className="material-icons " id="icd5gi">
        <>call</>
      </span>
      
      </span>
      
      </div>
      
      <div id="ifwywf" className="">
      
      <div className="" id="io1lce">
        <>Celular</>
      </div>
      
      <div className="" id="i059oe">
        <>+504 3312-1575</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iv1klh" className="">
      
      <div id="ilxpso" className="">
      
      <span className="material-icons " id="ivvuvm">
        
      <span className="material-icons " id="izfm5r">
        
      <span className="material-icons " id="itltu2">
        <>mail</>
      </span>
      
      </span>
      
      </span>
      
      </div>
      
      <div id="iqfrtm" className="">
      
      <div className="" id="ip5kmw">
        <>Correo</>
      </div>
      
      <div className="" id="i5lqjg">
        <>vita@vitarestauranthn.com</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iv3jzy" className="">
      
      <div id="i959v1" className="">
      
      <span className="material-icons " id="ii1v3p">
        
      <span className="material-icons " id="i1iqy9">
        
      <span className="material-icons " id="i242rg">
        
      <span className="material-icons " id="i51i7b">
        <>location_on</>
      </span>
      
      </span>
      
      </span>
      
      </span>
      
      </div>
      
      <div id="igtacw" className="">
      
      <div className="" id="i162yk">
        <>Ubicacion</>
      </div>
      
      <div className="" id="is0mgu">
        <>Mall La Galería, tercer piso, local 304, 11101 Tegucigalpa,</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i9vodj" className="">
      
      <div className="" id="iz1brc">
        <>También puedes escribirnos a través del siguiente formulario y te responderemos lo antes posible:</>
      </div>
      
      </div>
      
      <div id="i3rqt" className="">
      
        <div className="" id="i0az1">
          
      <form
        id="iq0mn"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
				} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="id17a" className="">
      
      <label id="iejaf" className="">
      <>Numero Invitados</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="guestsnumber"
        type="number"
        placeholder="Guests Number"
        className=""
        id="ia3ea"
      />
      
      </div>
      
      <div id="isrxl" className="">
      
      <label id="iy7kh" className="">
      <>Nombre Completo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="namecontact"
        type="text"
        placeholder="NameContact"
        className=""
        id="iapdh"
      />
      
      </div>
      
      <div id="ic7qx" className="">
      
      <label id="i9dmk" className="">
      <>Numero </>
      </label>
      
      <br className="" id="" />
      
      <input
        name="phonenumber"
        type="text"
        placeholder="phonenumber"
        className=""
        id="ibheyr"
      />
      
      </div>
      
      <div id="imy5jr" className="">
      
      <label id="izs5vx" className="">
      <>Fecha</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="dateres"
        type="date"
        placeholder=""
        className=""
        id="ilob42"
      />
      
      </div>
      
      <div id="i3vu4u" className="">
      
      <label id="idv16v" className="">
      <>Hora</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="hourres"
        type="time"
        placeholder=""
        className=""
        id="iy64rd"
      />
      
      </div>
      
      <div id="ieu3yq" className="">
      
      <button
        type="submit"
        name=""
        id="izeqd3"
        className=""
        
      >
      
      <div id="ik9nfi" className="">
      <>Reservar</>
      </div>
      
      </button>
      
      </div>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i2061" className="">
      
      <div id="iq0b9" className="">
      
      </div>
      
      <div id="iizhn" className="">
      
      <div id="izaiq" className="">
      
      <img
        className=""
        id="ihepdb"
        src="https://assetsprojects.s3.amazonaws.com/404pziimern109r.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i0hei" className="">
      
        <a
          target=""
          className=""
          id="iu98r"
          href="#"
        >
          
    <div id="ixdpz" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iam0d"
          href="#"
        >
          
    <div id="inoxt" className="">
    <>Menu</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iigdg"
          href="#"
        >
          
    <div id="iocf4" className="">
    <>Contacto</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      <div id="icv2g" className="">
      
      </div>
      
      <div id="ics7l" className="">
      
        <a
          target=""
          className=""
          id="i7f4f"
          href="#"
        >
          
      <img
        className=""
        id="i5u1b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb70qgrj.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="ivriv"
          href="#"
        >
          
      <img
        className=""
        id="i0mqz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb70qw8z.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="icv2s"
          href="#"
        >
          
      <img
        className=""
        id="ixnni"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb70r22p.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="ihhz2" className="">
      
      </div>
      
      </div>
      
      <div id="il1wo" className="">
      
      <div className="" id="i732cg">
        <>Copyright © 2025.Vita . Todos derechos reservados</>
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontact);
  